<template>
  <b-container>
    <b-row class="my-1" v-if="$route.params.msg">
      <b-col>
        <b-alert :show="dismissCountDown"
              dismissible
              variant="success"
              class="text-center"
              @dismissed="dismissCountDown=0">
        {{ $route.params.msg }}
        </b-alert>
      </b-col>
    </b-row>
    <b-card border-variant="danger" header="Stripe Connect" header-bg-variant="danger" header-text-variant="white" align="left">
      <a :href="authorizationUri" class="btn btn-danger">Connect with Stripe</a>
    </b-card>
  </b-container>
</template>
<script>
import StripeConnectService from '@/services/StripeConnectService'
import { mapActions } from 'vuex'

export default {
  name: 'StripeConnectStart',
  data () {
    return {
      config: require('../config/config'),
      authorizationUri: null,
      dismissCountDown: 10
    }
  },
  mounted () {
    // check DB for connect stripeUserId
    // redirect if already set
    this.checkForStripeConnectUserId()
  },
  methods: {
    buildRedirectUri () {
      let authorizationUriData = {
        baseUri: 'https://connect.stripe.com/oauth/authorize',
        responseType: 'code',
        scope: 'read_write',
        redirectUri: this.config.stripe.redirectUri
      }

      this.authorizationUri = `${authorizationUriData.baseUri}?response_type=${authorizationUriData.responseType}&client_id=${this.config.stripe.clientId}&scope=${authorizationUriData.scope}&redirect_uri=${authorizationUriData.redirectUri}`
    },
    async checkForStripeConnectUserId () {
      let response = await StripeConnectService.fetchStripeUserId()
      if (response.data.stripeUserId) {
        // update state
        this.setStripeConnectUserId(response.data.stripeUserId)
        // redirect to home page
        this.$router.push({ name: 'Home' })
      } else {
        // update state
        this.setStripeConnectUserId(null)
        // build stripe auth URL
        this.buildRedirectUri()
      }
    },
    ...mapActions(['setStripeConnectUserId'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StripeConnectStart.vue